/* eslint-disable prettier/prettier */

import { standaloneSubtypes } from '@shared/enums/packaging-subtype';

export const containerStandaloneMainMaterials: any = {
  BOTTLE: {
    GLASS: [
      'GLASS_BOTTLE_BOTTLE',
      'GLASS_BOTTLE_FLASK',
      'GLASS_BOTTLE_CAN',
      'GLASS_BOTTLE_CONTAINER',
      'GLASS_BOTTLE_JAR',
    ],
  },
  BOX: {
    PAPER_AND_CARDBOARD: ['PAPER_AND_CARDBOARD_BOX_BOX'],
    WOOD: ['WOOD_BOX_BOX'],
    METAL: ['METAL_BOX_CAN', 'METAL_BOX_BOX'],
    PLASTIC: [
      'PLASTIC_BOX_TOOLS',
      'PLASTIC_BOX_DISPOSABLE_CONTAINER',
      'PLASTIC_BOX_OTHER',
    ],
    ALUMINUM: ['ALUMINUM_BOX_BARREL'],
  },
  PLASTIC_BOTTLE: {
    PLASTIC: ['PLASTIC_PLASTIC_BOTTLE_DISPOSABLE_CONTAINER'],
  },
  BARREL: {
    WOOD: ['WOOD_BARREL_BARREL'],
    METAL: ['METAL_BARREL_BARREL', 'METAL_BARREL_TANK'],
    ALUMINUM: ['ALUMINUM_BARREL_BARREL'],
    PLASTIC: [
      'PLASTIC_BARREL_TOOLS',
      'PLASTIC_BARREL_DISPOSABLE_CONTAINER',
      'PLASTIC_BARREL_OTHER',
    ],
    CERAMICS: ['CERAMICS_BARREL_JUG'],
  },
  KEY_KEG: {
    METAL: ['METAL_KEY_KEG_BARREL'],
  },
  JUG: {
    METAL: ['METAL_JUG_BOX'],
    ALUMINUM: ['ALUMINUM_JUG_BARREL'],
    PLASTIC: [
      'PLASTIC_JUG_TOOLS',
      'PLASTIC_JUG_DISPOSABLE_CONTAINER',
      'PLASTIC_JUG_OTHER',
    ],
  },
  CANISTER: {
    GLASS: ['GLASS_CANISTER_CANISTER'],
    PLASTIC: [
      'PLASTIC_CANISTER_TOOLS',
      'PLASTIC_CANISTER_DISPOSABLE_CONTAINER',
      'PLASTIC_CANISTER_OTHER',
    ],
  },
  OTHER: {
    GLASS: ['GLASS_OTHER_OTHER', 'GLASS_OTHER_VIAL', 'GLASS_OTHER_AMPOULE'],
    PAPER_AND_CARDBOARD: [
      'PAPER_AND_CARDBOARD_OTHER_CASE',
      'PAPER_AND_CARDBOARD_OTHER_BAG',
      'PAPER_AND_CARDBOARD_OTHER_MULTI_LAYERED',
      'PAPER_AND_CARDBOARD_OTHER_CORRUGATED',
      'PAPER_AND_CARDBOARD_OTHER_COVERED_BY_KAOLIN',
      'PAPER_AND_CARDBOARD_OTHER_COVERED_BY_CELLULOSE',
      'PAPER_AND_CARDBOARD_OTHER_OTHER',
      'PAPER_AND_CARDBOARD_OTHER_LABEL',
      'PAPER_AND_CARDBOARD_OTHER_OTHER_SHAPED',
    ],
    METAL: ['METAL_OTHER_BOX'],
    ALUMINUM: [
      'ALUMINUM_OTHER_FOIL',
      'ALUMINUM_OTHER_BARREL',
      'ALUMINUM_OTHER_HOUSEHOLD_PRODUCT',
    ],
    PLASTIC: [
      'PLASTIC_OTHER_SELF_ADHESIVE_SHEET',
      'PLASTIC_OTHER_OTHER_UNREINFORCED_SHEET',
      'PLASTIC_OTHER_OTHER_SHEET',
      'PLASTIC_OTHER_TOOLS',
      'PLASTIC_OTHER_DISPOSABLE_CONTAINER',
      'PLASTIC_OTHER_OTHER',
    ],
    CERAMICS: ['CERAMICS_OTHER_JUG'],
    VULCANIZED_SOFT_RUBBER: ['VULCANIZED_SOFT_RUBBER_OTHER_TOOLS'],
    OTHER: ['OTHER_OTHER_FLEXIBLE_HOSE', 'OTHER_OTHER_BAG'],
  },
};

export const containerCollectionMainMaterials: any = {
  CHEST: {
    WOOD: ['WOOD_CHEST_CHEST'],
    PAPER_AND_CARDBOARD: ['PAPER_AND_CARDBOARD_CHEST_CHEST'],
    METAL: ['METAL_CHEST_BOX'],
    ALUMINUM: ['ALUMINUM_CHEST_BARREL'],
    PLASTIC: ['PLASTIC_CHEST_TOOLS', 'PLASTIC_CHEST_OTHER'],
    VULCANIZED_SOFT_RUBBER: ['VULCANIZED_SOFT_RUBBER_CHEST_TOOLS'],
  },
  CRATE: {
    WOOD: ['WOOD_CRATE_CRATE'],
    METAL: ['METAL_CRATE_BOX'],
    ALUMINUM: ['ALUMINUM_CRATE_BARREL'],
    PLASTIC: ['PLASTIC_CRATE_TOOLS', 'PLASTIC_CRATE_OTHER'],
    VULCANIZED_SOFT_RUBBER: ['VULCANIZED_SOFT_RUBBER_CRATE_TOOLS'],
  },
  PALLET: {
    WOOD: [
      'WOOD_PALLET_PALLET',
      'WOOD_PALLET_OTHER_PALLET',
      'WOOD_PALLET_PALLET_FRAME',
    ],
  },
  CARTON_OR_BOX: {
    WOOD: ['WOOD_CARTON_OR_BOX_BOX'],
    PAPER_AND_CARDBOARD: ['PAPER_AND_CARDBOARD_CARTON_OR_BOX_BOX_BOX'],
    METAL: ['METAL_CARTON_OR_BOX_BOX'],
    ALUMINUM: ['ALUMINUM_CARTON_OR_BOX_BARREL'],
    PLASTIC: ['PLASTIC_CARTON_OR_BOX_TOOLS'],
  },
  SHRINK: {
    PLASTIC: [
      'PLASTIC_SHRINK_SELF_ADHESIVE_SHEET',
      'PLASTIC_SHRINK_OTHER_UNREINFORCED_SHEET',
      'PLASTIC_SHRINK_OTHER_SHEET',
    ],
  },
  TRAY: {
    PAPER_AND_CARDBOARD: [
      'PAPER_AND_CARDBOARD_TRAY_MULTI_LAYERED',
      'PAPER_AND_CARDBOARD_TRAY_CORRUGATED',
      'PAPER_AND_CARDBOARD_TRAY_COVERED_BY_KAOLIN',
      'PAPER_AND_CARDBOARD_TRAY_COVERED_BY_CELLULOSE',
    ],
  },
  OTHER: {
    WOOD: ['WOOD_OTHER_BARREL'],
    PAPER_AND_CARDBOARD: [
      'PAPER_AND_CARDBOARD_OTHER_MULTI_LAYERED',
      'PAPER_AND_CARDBOARD_OTHER_CORRUGATED',
      'PAPER_AND_CARDBOARD_OTHER_COVERED_BY_KAOLIN',
      'PAPER_AND_CARDBOARD_OTHER_COVERED_BY_CELLULOSE',
      'PAPER_AND_CARDBOARD_OTHER_OTHER',
      'PAPER_AND_CARDBOARD_OTHER_LABEL',
      'PAPER_AND_CARDBOARD_OTHER_OTHER_SHAPED',
    ],
    ALUMINUM: [
      'ALUMINUM_OTHER_FOIL',
      'ALUMINUM_OTHER_BARREL',
      'ALUMINUM_OTHER_HOUSEHOLD_PRODUCT',
    ],
    PLASTIC: [
      'PLASTIC_OTHER_SELF_ADHESIVE_SHEET',
      'PLASTIC_OTHER_OTHER_UNREINFORCED_SHEET',
      'PLASTIC_OTHER_OTHER_SHEET',
      'PLASTIC_OTHER_OTHER',
    ],
    VULCANIZED_SOFT_RUBBER: ['VULCANIZED_SOFT_RUBBER_OTHER_TOOLS'],
    OTHER: [
      'OTHER_OTHER_EDGE_PROTECTOR',
      'OTHER_OTHER_FLEXIBLE_HOSE',
      'OTHER_OTHER_DEHUMIDIFIER',
    ],
  },
};

export type ContainerStandaloneUnit = typeof containerStandaloneUnits[number];
export const containerStandaloneUnits = ['LITERS', 'KILOGRAMS'] as const;

export const containerStandaloneSubtypes = [
  ...standaloneSubtypes.filter(
    (type) => type !== 'CLOSING' && type !== 'BAG_IN_BOX'
  ),
] as const;
export type ContainerStandaloneSubtype =
  typeof containerStandaloneSubtypes[number];
